import type { SupportAccount, SupportAccountIdType, SupportAccounts, SupportAccountsFilter, SupportAccountsOrderBy } from '../stateTypes'

export const indexSupportAccounts = (parsed: SupportAccount[] | any) => {
  const supportAccountIds = (Array.isArray(parsed) ? parsed : []) as SupportAccount[]
  const map = new Map<number, SupportAccount>()
  for (const acc of supportAccountIds) {
    if (!(acc?.accountid >= 0)) {
      console.error('invalid support account', acc)
      continue
    }
    const existing = map.get(+acc.accountid)
    if (existing?.signature && existing.membershipStatus === 0) {
      continue // skip duplicated id
    }
    if (acc.support_account_id === undefined) {
      Object.defineProperties(acc, {
        id: { value: String(acc.accountid) },
        support_account_id: { get: () => String(acc.accountid) },
        support_account_name: { get: () => acc.name },
        displayName: { value: `${acc.name} - ${acc.accountid}` },
      })
    }
    map.set(+acc.accountid, acc)
  }
  const filtered = Array.from(map.values())
  const filterFn: SupportAccountsFilter = (predicate, thisArg) => {
    return indexSupportAccounts(Array.prototype.filter.call(filtered, predicate, thisArg))
  }
  const orderByFn: SupportAccountsOrderBy = (field: 'id' | 'accountid' | 'name') => {
    const fieldName = !field || field.endsWith('name') ? 'name' : 'accountid'
    const array = Array.from(filtered).sort(fieldName === 'name' ? (a, b) => {
      const aname = a.name.toLowerCase()
      const bname = b.name.toLowerCase()
      if (aname > bname) {
        return 1
      }
      if (bname > aname) {
        return -1
      }
      return 0
    } : (a, b) => {
      if (a.accountid > b.accountid) {
        return 1
      }
      if (b.accountid > a.accountid) {
        return -1
      }
      return 0
    })
    return indexSupportAccounts(array)
  }
  const hasAccount = (cspId: SupportAccountIdType = null) => (cspId !== null ? map.has(+cspId) : undefined)
  const getAccount = (cspId: SupportAccountIdType = null) => (cspId !== null ? map.get(+cspId) : undefined)
  Object.defineProperties(filtered, {
    _map: { value: map },
    has: { value: hasAccount },
    get: { value: getAccount },
    filter: { value: filterFn },
    filterBy: { value: filterFn },
    orderBy: { value: orderByFn },
  })
  return filtered as SupportAccounts
}
indexSupportAccounts.fromError = (error: Error) => {
  const indexed = indexSupportAccounts([])
  indexed.error = error
  return indexed
}

export default indexSupportAccounts
